module.exports = {"410182001":"索河街道","410182002":"京城路街道","410182101":"乔楼镇","410182102":"豫龙镇","410182103":"广武镇","410182104":"王村镇","410182105":"汜水镇","410182106":"高山镇","410182108":"刘河镇","410182109":"崔庙镇","410182110":"贾峪镇","410182200":"城关乡","410182201":"高村乡","410182204":"金寨回族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410182.json
// module id = 1524
// module chunks = 0